<template>
  <div class="transcript-container">
    <div class="transcript" ref="transcriptContainer">
      <div
        v-for="(message, index) in messages"
        :key="index"
        :class="['message', message.role]"
      >
        <div class="message-content">{{ message.content }}</div>
        <div class="message-time">{{ message.time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BSPTranscript",
  props: {
    messages: {
      type: Array,
      required: true
    }
  },
  watch: {
    messages: {
      handler () {
        this.$nextTick(() => {
          if (this.$refs.transcriptContainer) {
            this.$refs.transcriptContainer.scrollTop = this.$refs.transcriptContainer.scrollHeight
          }
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.transcript-container {
  flex: 1;
  overflow: hidden;
  border: 1px solid $slate20;
  border-radius: 4px;
  background-color: $slate05;
}

.transcript {
  height: 100%;
  overflow-y: auto;
  padding: 1rem;
}

.message {
  margin-bottom: 1rem;
  max-width: 80%;

  &.user {
    margin-left: auto;

    .message-content {
      background-color: $orange;
      color: $white;
      border-radius: 18px 18px 4px 18px;
    }
  }

  &.assistant {
    margin-right: auto;

    .message-content {
      background-color: $white;
      border-radius: 18px 18px 18px 4px;
    }
  }

  &.system {
    margin: 0 auto;
    text-align: center;
    max-width: 100%;

    .message-content {
      background-color: transparent;
      color: $slate60;
      font-style: italic;
    }
  }

  .message-content {
    padding: 0.75rem 1rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .message-time {
    font-size: 0.8rem;
    color: $slate60;
    margin-top: 0.25rem;
    text-align: right;
  }
}
</style>
